/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade?: string | null;
  enabled?: boolean;
}

export interface PropostaCopiavel {
  /** Data já formatada como dd/MM/yyyy pelo backend. */
  dataCriacao: string;
  /** Valor já formatado como "R$ 0.000,00" pelo backend. */
  valorTotal: string;
  status: string;
  numeroCotacao: string;
  /** Id da proposta, enviado como idPropostaSelecionada na cópia. */
  propostaId: string;
}

/**
 * Lista as propostas da unidade de origem escolhida.
 *
 * Só retornam propostas ativas: as que estão em simulação, rescindidas ou
 * canceladas são descartadas pelo backend, assim como as vinculadas a tabelas
 * de venda inativas.
 */
export function useGetPropostasUnidadeCopiaProposta(props: Props) {
  const GET_PROPOSTAS = `${backofficeEnviroment}/common/oportunidades-lead/copia-proposta/propostas/v1/${props.idUnidade}`;

  const fetchData = async () => {
    const response = await instance.get(GET_PROPOSTAS);
    return {
      propostas: (response?.data?.data?.propostas || []) as PropostaCopiavel[],
      totalRegistros: response?.data?.data?.totalRegistros ?? 0,
    };
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["copia-proposta-propostas-unidade", props.idUnidade],
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: Boolean(props.enabled && props.idUnidade),
    onError: (error: any) => {
      notificarErroApi("Erro ao buscar propostas da unidade", error);
    },
  });

  return query;
}
